module.exports = __webpack_public_path__ + "static/young-leader-photo-katherine_marie_robinson-bd4181e37f1dd06ee4943d8025674cca.jpg";